import { render, staticRenderFns } from "./subDistrictOfficeData.vue?vue&type=template&id=5a90e45a&scoped=true"
import script from "./subDistrictOfficeData.vue?vue&type=script&lang=js"
export * from "./subDistrictOfficeData.vue?vue&type=script&lang=js"
import style0 from "./subDistrictOfficeData.vue?vue&type=style&index=0&id=5a90e45a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90e45a",
  null
  
)

export default component.exports